/* ===== FAQ 数据 ===== */
export const faqItems = [
  {
    question: "51吃瓜网是什么类型的网站？",
    answer: "51吃瓜最新网址是一个汇聚娱乐圈八卦、明星动态、综艺热点和热门话题的综合资讯平台，提供51吃瓜在线观看、视频在线播放等服务，支持手机版、安卓iOS轻量版APP，是吃瓜爱好者的一站式内容社区。"
  },
  {
    question: "如何在手机上使用51吃瓜网？",
    answer: "你可以通过手机浏览器直接访问51吃瓜最新网址在线版，也可以下载51吃瓜安卓轻量版或iOS轻量版APP。轻量版经过深度优化，加载速度快、省流量，让你随时随地在线观看吃瓜视频，体验流畅不卡顿。"
  },
  {
    question: "51吃瓜网的内容多久更新一次？",
    answer: "我们每天24小时不间断更新内容，重大娱乐圈事件发生后最快15分钟内即可在站内看到相关吃瓜报道。同时51吃瓜在线播放和视频板块也保持高频更新，确保你不错过任何精彩吃瓜视频。"
  },
  {
    question: "51吃瓜网提供哪些类型的吃瓜内容？",
    answer: "覆盖明星八卦恋情、综艺节目路透、影视资讯追踪、网红翻车实录、时尚红毯造型、直播精彩瞬间、热搜话题追踪、粉丝圈热议等多个板块，51吃瓜在线观看让你吃瓜视频一网打尽。"
  }
];

/* ===== 联系方式数据 ===== */
export const contactInfo = {
  title: "投稿爆料 / 商务合作",
  description: "如果你有独家吃瓜线索、娱乐圈内幕爆料，或者有商务合作需求，欢迎通过以下方式联系我们。51吃瓜最新网址期待与你一起挖掘更多精彩内容。",
  email: "contact@51chigua.com",
  wechat: "51chigua_official"
};

/* ===== 话题标签数据 ===== */
export const topicTags = [
  { name: "明星恋情", hot: true, count: "12.8万" },
  { name: "综艺路透", hot: true, count: "9.6万" },
  { name: "影视热议", hot: true, count: "8.2万" },
  { name: "网红翻车", hot: false, count: "7.5万" },
  { name: "红毯造型", hot: false, count: "6.3万" },
  { name: "圈内内幕", hot: true, count: "15.1万" },
  { name: "直播精选", hot: false, count: "5.7万" },
  { name: "热搜追踪", hot: true, count: "11.4万" },
  { name: "粉丝热议", hot: false, count: "4.9万" },
  { name: "跨界爆料", hot: true, count: "8.8万" }
];

/* ===== 图文卡片数据 ===== */
export const cardItems = [
  {
    title: "顶流男星深夜密会神秘女子",
    summary: "某当红男星被拍到深夜与神秘女子同行，举止亲密引发全网猜测，粉丝集体炸锅。",
    image: "https://readdy.ai/api/search-image?query=Stylish%20modern%20entertainment%20media%20concept%20with%20warm%20amber%20and%20coral%20lighting%2C%20abstract%20representation%20of%20celebrity%20gossip%20news%2C%20soft%20editorial%20photography%20style%2C%20golden%20hour%20tones%2C%20sophisticated%20composition%20with%20geometric%20elements%2C%20clean%20aesthetic%20with%20depth%20and%20drama&width=800&height=500&seq=card-01&orientation=landscape",
    tag: "独家爆料",
    time: "2小时前"
  },
  {
    title: "热门综艺录制突发状况",
    summary: "某王牌综艺录制现场突发意外，导演紧急叫停，现场观众爆出惊人内幕，节目组暂未回应。",
    image: "https://readdy.ai/api/search-image?query=Contemporary%20variety%20show%20production%20concept%20with%20dramatic%20studio%20lighting%2C%20warm%20red%20and%20gold%20accents%2C%20artistic%20television%20entertainment%20scene%2C%20spotlight%20effects%2C%20creative%20editorial%20composition%2C%20modern%20media%20aesthetic%20with%20energy&width=800&height=500&seq=card-02&orientation=landscape",
    tag: "综艺热议",
    time: "3小时前"
  },
  {
    title: "当红小花素颜出街被拍",
    summary: "素颜状态下的某人气女星被路人偶遇拍摄，与精修图差距明显，网友直呼认不出，引发关于真实颜值的讨论。",
    image: "https://readdy.ai/api/search-image?query=Fashionable%20street%20photography%20concept%20in%20warm%20afternoon%20light%2C%20abstract%20editorial%20portrait%20style%2C%20soft%20coral%20and%20peach%20tones%2C%20modern%20minimalist%20composition%2C%20lifestyle%20aesthetic%20with%20natural%20textures%2C%20cinematic%20mood&width=800&height=500&seq=card-03&orientation=landscape",
    tag: "明星日常",
    time: "5小时前"
  },
  {
    title: "大牌代言翻车品牌紧急声明",
    summary: "某国际品牌代言人陷入争议，品牌方连夜发布声明撇清关系，网友却扒出更多疑点，真相到底如何？",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20editorial%20concept%20with%20luxury%20brand%20aesthetic%2C%20warm%20gold%20and%20deep%20coral%20lighting%2C%20contrasting%20shadows%20and%20highlights%2C%20sophisticated%20fashion%20commercial%20photography%20style%2C%20clean%20geometric%20composition%2C%20tension%20and%20intrigue%20atmosphere&width=800&height=500&seq=card-04&orientation=landscape",
    tag: "品牌风波",
    time: "6小时前"
  },
  {
    title: "演唱会后台独家花絮流出",
    summary: "某天王级歌手演唱会后台温馨瞬间被工作人员曝光，私下反差萌圈粉无数，粉丝直呼太可爱了。",
    image: "https://readdy.ai/api/search-image?query=Concert%20backstage%20atmosphere%20concept%20with%20warm%20stage%20lighting%2C%20golden%20and%20amber%20tones%2C%20musical%20performance%20aesthetic%2C%20dramatic%20spotlight%20effects%20through%20fog%2C%20editorial%20documentary%20style%2C%20intimate%20mood%20with%20energy&width=800&height=500&seq=card-05&orientation=landscape",
    tag: "独家花絮",
    time: "8小时前"
  },
  {
    title: "影视圈大佬聚会暗藏玄机",
    summary: "多位影视行业重量级人物私下聚会照片流出，疑似有大项目即将启动，吃瓜群众纷纷猜测阵容。",
    image: "https://readdy.ai/api/search-image?query=Elegant%20dinner%20party%20atmosphere%20with%20warm%20candlelight%2C%20luxury%20interior%20design%2C%20soft%20golden%20and%20amber%20lighting%2C%20sophisticated%20social%20gathering%20aesthetic%2C%20editorial%20documentary%20photography%20style%2C%20mysterious%20and%20intriguing%20mood&width=800&height=500&seq=card-06&orientation=landscape",
    tag: "行业动态",
    time: "10小时前"
  },
  {
    title: "知名网红陷入争议粉丝脱粉",
    summary: "拥有千万粉丝的某头部网红因不当言论被群嘲，评论区沦陷，大量粉丝取关，品牌合作恐受影响。",
    image: "https://readdy.ai/api/search-image?query=Modern%20social%20media%20controversy%20concept%20with%20dramatic%20warm%20coral%20and%20deep%20red%20lighting%2C%20digital%20culture%20aesthetic%2C%20abstract%20representation%20of%20online%20drama%2C%20editorial%20photography%20style%2C%20intense%20atmosphere%20with%20contrast&width=800&height=500&seq=card-07&orientation=landscape",
    tag: "网红争议",
    time: "12小时前"
  }
];

/* ===== 媒体卡片数据 ===== */
export const mediaItems = [
  {
    title: "独家：某综艺录制幕后花絮全纪录",
    summary: "直击热门综艺录制现场，揭秘明星真实互动状态，幕后故事比正片更精彩。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20of%20television%20production%2C%20warm%20studio%20lighting%20with%20golden%20and%20amber%20tones%2C%20professional%20camera%20equipment%20silhouettes%2C%20creative%20film%20set%20atmosphere%2C%20editorial%20documentary%20style%2C%20dynamic%20composition%20with%20depth&width=1200&height=700&seq=media-01&orientation=landscape",
    duration: "15:32",
    views: "128.6万"
  },
  {
    title: "某顶流明星机场街拍全程追踪",
    summary: "从落地到离开全程跟拍，私服穿搭细节全解析，明星私下真实状态大公开。",
    image: "https://readdy.ai/api/search-image?query=Sleek%20airport%20fashion%20photography%20concept%20with%20warm%20natural%20lighting%2C%20modern%20architecture%20background%2C%20soft%20coral%20and%20beige%20tones%2C%20editorial%20street%20style%20aesthetic%2C%20clean%20composition%20with%20movement%20and%20candid%20mood&width=1200&height=700&seq=media-02&orientation=landscape",
    duration: "08:45",
    views: "96.3万"
  },
  {
    title: "大型活动红毯精彩瞬间回顾",
    summary: "年度盛典红毯环节高光时刻合集，明星造型PK、互动名场面一次看够。",
    image: "https://readdy.ai/api/search-image?query=Glamorous%20red%20carpet%20event%20concept%20with%20dramatic%20lighting%2C%20warm%20gold%20and%20coral%20accents%2C%20elegant%20fashion%20photography%20style%2C%20paparazzi%20flash%20effects%2C%20sophisticated%20editorial%20composition%2C%20celebrity%20gala%20atmosphere&width=1200&height=700&seq=media-03&orientation=landscape",
    duration: "22:18",
    views: "215.7万"
  }
];

/* ===== 排行榜数据 ===== */
export const rankingItems = [
  { rank: 1, title: "顶流男星恋情疑似曝光，女方身份引热议", hot: "🔥 298万", trend: "up", tag: "新" },
  { rank: 2, title: "热门综艺总决赛赛制争议，观众不满", hot: "🔥 256万", trend: "up", tag: "热" },
  { rank: 3, title: "当红女星新剧路透造型惊艳全网", hot: "🔥 213万", trend: "up", tag: "热" },
  { rank: 4, title: "某头部网红涉嫌虚假宣传被举报", hot: "189万", trend: "down", tag: "" },
  { rank: 5, title: "影视圈年度盛典幕后花絮大公开", hot: "167万", trend: "up", tag: "" },
  { rank: 6, title: "某偶像组合成员退团内幕深度分析", hot: "145万", trend: "up", tag: "爆" },
  { rank: 7, title: "跨年演唱会首批阵容曝光引期待", hot: "132万", trend: "new", tag: "新" }
];

/* ===== 特色优势数据 ===== */
export const featureItems = [
  {
    icon: "ri-flashlight-line",
    title: "实时追踪",
    description: "全天候24小时不间断更新，重大事件最快15分钟内上线，热搜话题第一时间跟进，51吃瓜在线播放随时可看。"
  },
  {
    icon: "ri-smartphone-line",
    title: "多端覆盖",
    description: "支持手机版、电脑版、安卓iOS轻量版APP全平台访问，51吃瓜手机版随时随地在线观看吃瓜视频。"
  },
  {
    icon: "ri-stack-line",
    title: "海量内容",
    description: "覆盖明星八卦、综艺、影视、网红、时尚等8大板块，吃瓜视频一网打尽，51吃瓜网在线满足你的吃瓜需求。"
  },
  {
    icon: "ri-rocket-line",
    title: "轻量体验",
    description: "51吃瓜轻量版深度优化，极速加载省流量，低端机型也能流畅使用，51吃瓜下载轻量版体验丝滑浏览。"
  }
];

/* ===== 动态更新数据 ===== */
export const updateItems = [
  { date: "07.30", title: "某韩团回归预告片播放量破千万，粉丝狂欢", tag: "最新" },
  { date: "07.29", title: "某古装剧最新路透照流出，服化道造型惊艳网友", tag: "热门" },
  { date: "07.29", title: "某综艺节目下期预告曝光，内容引发全网猜测", tag: "" },
  { date: "07.28", title: "某明星工作室就网络谣言发布律师函声明", tag: "" },
  { date: "07.28", title: "某大型音乐节完整阵容公布，粉丝沸腾", tag: "热门" },
  { date: "07.27", title: "某选秀节目黑马选手逆袭晋级，弹幕刷屏", tag: "" },
  { date: "07.27", title: "某国际品牌代言人更换消息引全网讨论", tag: "热议" }
];

/* ===== APP下载入口数据 ===== */
export const appInfo = {
  title: "51吃瓜轻量版APP",
  description: "专为吃瓜爱好者打造的轻量级应用，支持51吃瓜安卓下载和iOS下载。极速加载、省流量、推送提醒，不错过任何一个热搜吃瓜视频。扫码下载或通过应用商店搜索「51吃瓜」即可安装。",
  androidUrl: "#app",
  iosUrl: "#app",
  features: ["极速加载", "省流模式", "推送提醒", "夜间模式", "离线缓存"]
};

/* ===== 关于平台数据 ===== */
export const aboutInfo = {
  title: "关于51吃瓜最新网址",
  paragraphs: [
    "51吃瓜最新网址成立于2020年，是中文互联网领先的娱乐八卦资讯聚合平台。我们致力于为吃瓜爱好者提供最新、最全、最快速的娱乐资讯和吃瓜视频服务。",
    "平台覆盖明星恋情八卦、综艺节目追踪、影视资讯速递、网红圈观察、时尚潮流解析、直播精彩集锦等多个内容板块，51吃瓜在线观看入口让用户随时随地畅享吃瓜乐趣。",
    "目前51吃瓜网在线日均服务超过千万吃瓜用户，支持手机版、安卓iOS轻量版多端访问。51吃瓜下载轻量版APP享受更流畅的浏览体验，吃瓜视频一网打尽。"
  ],
  stats: [
    { label: "日均更新", value: "200+" },
    { label: "内容板块", value: "8大" },
    { label: "活跃用户", value: "千万级" },
    { label: "运营年限", value: "6年+" }
  ]
};

/* ===== 焦点专题横向卡片数据 ===== */
export const carouselItems = [
  {
    title: "暑期档影视大盘点",
    summary: "爆款剧集、黑马电影一网打尽，这个夏天最值得追的内容都在这里。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20marathon%20concept%20with%20warm%20golden%20sunset%20lighting%2C%20film%20reel%20and%20popcorn%20aesthetic%2C%20cozy%20home%20theater%20atmosphere%2C%20soft%20coral%20and%20amber%20tones%2C%20editorial%20entertainment%20photography%20style&width=1000&height=600&seq=carousel-01&orientation=landscape",
    tag: "影视专题"
  },
  {
    title: "年度十大综艺名场面",
    summary: "笑到停不下来、感动到泪目的经典瞬间，重温那些综艺高光时刻。",
    image: "https://readdy.ai/api/search-image?query=Variety%20show%20highlight%20moments%20concept%20with%20bright%20studio%20lighting%2C%20colorful%20confetti%20and%20celebration%20aesthetic%2C%20warm%20golden%20and%20coral%20accents%2C%20joyful%20entertainment%20photography%2C%20dynamic%20composition%20with%20energy%20and%20excitement&width=1000&height=600&seq=carousel-02&orientation=landscape",
    tag: "综艺盘点"
  },
  {
    title: "娱乐圈上半年大事记",
    summary: "从惊天爆料到甜蜜官宣，2026上半年娱乐圈最值得记住的那些事。",
    image: "https://readdy.ai/api/search-image?query=Timeline%20collage%20of%20entertainment%20news%20highlights%2C%20warm%20vintage%20editorial%20style%2C%20soft%20coral%20and%20cream%20tones%2C%20newspaper%20and%20magazine%20aesthetic%2C%20sophisticated%20documentary%20photography%2C%20layered%20composition%20with%20depth&width=1000&height=600&seq=carousel-03&orientation=landscape",
    tag: "年度回顾"
  },
  {
    title: "明星情侣甜蜜互动合集",
    summary: "那些公开撒糖的高甜瞬间，让你再次相信爱情的娱乐圈模范情侣盘点。",
    image: "https://readdy.ai/api/search-image?query=Romantic%20couple%20moments%20concept%20with%20soft%20warm%20sunset%20lighting%2C%20golden%20hour%20aesthetic%2C%20tender%20editorial%20portrait%20style%2C%20soft%20coral%20and%20peach%20tones%2C%20dreamy%20atmosphere%20with%20bokeh%20effects%2C%20intimate%20and%20elegant%20composition&width=1000&height=600&seq=carousel-04&orientation=landscape",
    tag: "甜蜜合集"
  },
  {
    title: "热门IP改编影视剧追踪",
    summary: "小说、漫画改编影视作品进度一览，你最期待的IP有没有安排上？",
    image: "https://readdy.ai/api/search-image?query=Book%20to%20screen%20adaptation%20concept%20with%20warm%20library%20lighting%2C%20film%20script%20and%20novels%20aesthetic%2C%20soft%20amber%20and%20cream%20tones%2C%20creative%20storytelling%20atmosphere%2C%20editorial%20literary%20photography%20style%2C%20sophisticated%20composition&width=1000&height=600&seq=carousel-05&orientation=landscape",
    tag: "IP追踪"
  }
];

/* ===== 主题索引数据 ===== */
export const indexItems = [
  { title: "明星八卦大全", icon: "ri-user-star-line", count: "3,286篇", description: "明星恋情、私生活、活动现场一手资讯" },
  { title: "综艺节目追踪", icon: "ri-tv-line", count: "2,157篇", description: "最新路透、录制花絮、嘉宾互动全记录" },
  { title: "影视资讯速递", icon: "ri-film-line", count: "1,984篇", description: "新剧开播、票房战报、剧组动态及时更新" },
  { title: "网红圈观察", icon: "ri-live-line", count: "1,623篇", description: "网红翻车、带货实况、社交媒体热议追踪" },
  { title: "时尚潮流解析", icon: "ri-shirt-line", count: "1,247篇", description: "明星穿搭、红毯造型、品牌活动深度解析" },
  { title: "直播精彩集锦", icon: "ri-vidicon-line", count: "982篇", description: "直播间名场面、精彩切片、互动高光回顾" },
  { title: "话题热议排行", icon: "ri-fire-line", count: "876篇", description: "热搜追踪、话题讨论、全网热议内容汇总" }
];

/* ===== 评论数据 ===== */
export const commentItems = [
  {
    author: "吃瓜小能手",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20avatar%20concept%2C%20warm%20coral%20and%20peach%20gradient%20background%2C%20simple%20geometric%20human%20silhouette%2C%20modern%20flat%20design%20style%2C%20clean%20and%20friendly%20aesthetic&width=120&height=120&seq=avatar-01&orientation=squarish",
    time: "2小时前",
    content: "每天必刷的51吃瓜网站，更新速度真的快！今天的热搜还没上，这里就已经有详细报道了，吃瓜视频也很全，推荐给所有吃瓜爱好者~"
  },
  {
    author: "娱乐圈观察家",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20profile%20avatar%20design%2C%20warm%20golden%20amber%20gradient%2C%20simple%20circular%20geometric%20shape%2C%20modern%20professional%20look%2C%20clean%20flat%20icon%20aesthetic%2C%20friendly%20approachable%20style&width=120&height=120&seq=avatar-02&orientation=squarish",
    time: "5小时前",
    content: "终于找到组织啦！瓜友们都在这里交流，内容比微博还快一步。51吃瓜在线看视频也不卡，轻量版APP真的很好用。"
  },
  {
    author: "深夜吃瓜人",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20abstract%20avatar%20design%20with%20warm%20peach%20and%20cream%20gradient%2C%20minimalist%20geometric%20portrait%2C%20modern%20flat%20aesthetic%2C%20clean%20circular%20shape%2C%20friendly%20casual%20style&width=120&height=120&seq=avatar-03&orientation=squarish",
    time: "8小时前",
    content: "51吃瓜轻量版真的省流！晚上躺床上刷瓜一点都不心疼流量，加载速度也很快。安卓下载安装也简单，推荐大家都试试。"
  },
  {
    author: "追瓜少女",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20minimalist%20avatar%20concept%20with%20warm%20coral%20pink%20gradient%2C%20simple%20geometric%20face%20shape%2C%20modern%20flat%20illustration%20style%2C%20clean%20aesthetic%2C%20playful%20and%20friendly%20design&width=120&height=120&seq=avatar-04&orientation=squarish",
    time: "12小时前",
    content: "内容很全面，想看什么瓜都能找到。八卦、综艺、影视、网红，分了这么多板块，每天都要刷好几次51吃瓜网在线。"
  },
  {
    author: "老瓜农",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20amber%20and%20terracotta%20gradient%2C%20simple%20geometric%20design%2C%20professional%20clean%20look%2C%20modern%20flat%20style%2C%20trustworthy%20friendly%20aesthetic&width=120&height=120&seq=avatar-05&orientation=squarish",
    time: "1天前",
    content: "吃瓜吃了这么多年，还是51吃瓜最靠谱！信息准确度高，不会像某些平台乱传谣言。51吃瓜下载轻量版后更方便了。"
  }
];